import { mapCarouselGetFieldsToPostFields } from 'components/production/components/AisleContent/utils';

/**
 * Transforms a saved product spotlight carousel from the database into the
 * form data structure. The GET endpoint returns field names that differ from
 * what the form / POST endpoint expect.
 *
 * @param {Object} carousel - Raw carousel object from the API.
 * @returns {Object} Form-compatible data.
 */
export function transformProductSpotlightToFormData(carousel) {
    // rankNumber is not a valid field for the PUT/POST endpoints
    const { rankNumber, ...rest } = carousel;

    return mapCarouselGetFieldsToPostFields(rest);
}
